module.exports = __webpack_public_path__ + "img/avatar_real_7.c52b9b79.jpg";